export default __webpack_public_path__ + "static/media/volunteerTask.0324eaf2.png";